export default "__VITE_ASSET__DDf5tzmb__"